// Fields, defaults, and library info for this section. The editor builds its form from `fields`.
const definition = {
  order: 50,
  type: "featured_products",
  name: "Featured Products Grid",
  category: "Products",
  description: "Grid of real store products with filters, pricing, and fast cart action",
  defaultSettings: {
    title: "Trending This Season",
    subtitle: "Handpicked customer favorites and top rated arrivals",
    count: 8,
    columns: 4,
    filter: "featured",
    showBadge: true,
    aspectRatio: "portrait",
  },
  fields: [
    { key: "title", label: "Section Heading", type: "text" },
    { key: "subtitle", label: "Section Subtitle", type: "text" },
    {
      key: "filter",
      label: "Product Filter Mode",
      type: "select",
      options: [
        { value: "all", label: "All Products" },
        { value: "featured", label: "Featured Products Only" },
        { value: "popular", label: "Popular / Best Sellers" },
      ],
    },
    {
      key: "count",
      label: "Number of Products to Display",
      type: "select",
      options: [
        { value: 4, label: "4 Products" },
        { value: 8, label: "8 Products" },
        { value: 12, label: "12 Products" },
        { value: 16, label: "16 Products" },
      ],
    },
    {
      key: "columns",
      label: "Columns (Desktop)",
      type: "select",
      options: [
        { value: 3, label: "3 Columns" },
        { value: 4, label: "4 Columns" },
      ],
    },
    {
      key: "aspectRatio",
      label: "Product Image Aspect Ratio",
      type: "select",
      options: [
        { value: "portrait", label: "Editorial Portrait (3:4)" },
        { value: "square", label: "Standard Square (1:1)" },
      ],
    },
    { key: "showBadge", label: "Show Sale / Discount Badge", type: "toggle" },
  ],
};

export default definition;
